import React from 'react'
import AppStoreBadge from 'assets/images/ios-app-store-badge.png'
import PlayStoreBadge from 'assets/images/google-play-store-badge.png'
import PassportHeaderBG from 'assets/images/client-passport-header-bg.png'

const PassportHeader = () => (
  <div
    className="flex flex-col h-80 items-center justify-center bg-cover bg-center"
    style={{ backgroundImage: `url(${PassportHeaderBG})` }}
  >
    <div className="text-center">
      <h1 className="text-3xl font-normal">WELCOME TO FLYSPACE PASSPORT</h1>
      <p className="text-base font-normal">
        Passport is better with our apps, feautring a QR code reader for instant bookings!
      </p>
      <p className="text-base font-normal">Download now for a seamless check in experience!</p>
    </div>
    <div className="flex my-5">
      <a href="https://apps.apple.com/us/app/flyspaces/id1620335125">
        <img alt="appStore" width="153" height="55" className="w-40 mx-3 rounded-lg" src={AppStoreBadge} />
      </a>
      <a href="https://play.google.com/store/apps/details?id=com.flyspaces.client&hl=en">
        <img alt="playStore" width="162" height="55" className="w-40 mx-3 rounded-lg" src={PlayStoreBadge} />
      </a>
    </div>
  </div>
)

export default PassportHeader
